module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-500.6cad9967814c821174259b5dfa364550.woff2";